import type { GetStaticPropsContext } from 'next'
import ProductsArchiveRoute, { getProductsArchiveStaticProps } from '../features/products-archive/route'
import { makeStaticProps } from '../lib/next'

export default ProductsArchiveRoute

export async function getStaticProps(ctx: GetStaticPropsContext) {
  const { locale } = ctx
  const props = await getProductsArchiveStaticProps(locale)
  return makeStaticProps(props)
}
